import { render, staticRenderFns } from "./exhibition-home-project.vue?vue&type=template&id=6aa797b6&scoped=true&"
import script from "./exhibition-home-project.vue?vue&type=script&lang=js&"
export * from "./exhibition-home-project.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-home-project.vue?vue&type=style&index=0&id=6aa797b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa797b6",
  null
  
)

export default component.exports